module.exports = __webpack_public_path__ + "img/pic_erweima.5f09cfbc.png";